import { useRef, useState, useEffect } from "react";
import reloadImg from "../../../assets/images/reload.svg";
import arrowImg from "../../../assets/images/arrow-white-icon.svg";

import { useNavigate } from "react-router-dom";
import Header from "../../commonComponents/header/Header";
import { useNetworkResilientVideo } from "../../../hooks/useNetworkResilientVideo";

const AssessmentInegrity = () => {
  const navigate = useNavigate();
  const videoRef = useRef(null);
  useNetworkResilientVideo(videoRef);
  const maxAllowedTime = useRef(0);
  const isSeeking = useRef(false);

  const [isIntroStage, setIsIntroStage] = useState(true);
  const [isReplayFullscreen, setIsReplayFullscreen] = useState(false);
  const [showTopMode, setShowTopMode] = useState(false);
  const [isFirstWatch, setIsFirstWatch] = useState(true);

  // instruction animation (intro only)
  useEffect(() => {
    if (isIntroStage) {
      const t = setTimeout(() => setShowTopMode(true), 2000);
      return () => clearTimeout(t);
    }
  }, [isIntroStage]);
  const playFromBeginning = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
    }
  };
  // ===== INTRO VIDEO END =====
  const handleIntroEnd = () => {
    setIsFirstWatch(false);
    setIsIntroStage(false);
    setIsReplayFullscreen(false);
  };

  // ===== GO FULLSCREEN REPLAY =====
  const goFullscreenReplay = () => {
    setIsIntroStage(true);
    setIsReplayFullscreen(true);

    setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.currentTime = 0;
        videoRef.current.play();
      }
    }, 50);
  };

  const handleProceed = () => {
    const screenshotFlag =
      sessionStorage.getItem("mobileProctoringScreenshot") === "true";
    const videoFlag =
      sessionStorage.getItem("mobileProctoringVideo") === "true";
    const desktopAgentFlag = sessionStorage.getItem("desktopAgent") === "true";
    const whiteboardFlag =
      sessionStorage.getItem("whiteboarding_env") === "true";
    const codingFlag = sessionStorage.getItem("coding_env") === "true";
    if (screenshotFlag || videoFlag) {
      navigate("/needleeye-introduction");
    } else if (desktopAgentFlag) {
      navigate("/needleeye-desktop-introduction");
    } else if (codingFlag || whiteboardFlag)
       navigate("/demo-video");
      else navigate("/verification");
  };

  return (
    <div className="w-screen h-screen relative overflow-hidden">
      {/* ================= FULLSCREEN VIDEO ================= */}
      {isIntroStage && (
        <>
          <video
            ref={videoRef}
            className="w-full h-full object-contain bg-black"
            autoPlay
            controls
            disablePictureInPicture
            onEnded={handleIntroEnd}
          >
            <source
              src="https://t1developmentneedles.blob.core.windows.net/intro-videos/NH_Anti_Fraud_Notification.mp4?sp=r&st=2026-07-14T09:53:25Z&se=2031-04-09T18:08:25Z&sv=2026-02-06&sr=b&sig=QfgvxNH0w6TIWU1KPUo1lDXacXQ9XPNNj9RAcAsKTdE%3D"
              type="video/mp4"
            />
          </video>

          {/* Block seek bar on first watch only */}
          {isFirstWatch && (
            <div className="absolute bottom-0 left-0 w-full h-[50px] z-10" />
          )}

          {/* Instruction only on first intro */}
          {!isReplayFullscreen && (
            <div
              className={`
                absolute left-1/2 -translate-x-1/2
                px-8 py-2 rounded-2xl
               bg-[#111729]/95 backdrop-blur-md text-center
                transition-all duration-700
                ${
                  showTopMode
                    ? "top-1 max-w-[720px]"
                    : "top-1/2 -translate-y-1/2 max-w-[720px]"
                }
              `}
            >
              {!showTopMode && (
                <p className="text-white app-video-overlay  font-medium mb-2">
                  Please attentively watch this video…
                </p>
              )}
              <p className="text-white/90 app-body">
                You will be able to proceed once the video has ended.
              </p>
            </div>
          )}

          {/* Replay fullscreen buttons */}
          {isReplayFullscreen && (
            <div className="absolute bottom-8 right-8 flex gap-3 z-20">
              <button
                onClick={playFromBeginning}
                className="app-button flex bg-btnBgColor items-center px-6 py-1.5 text-white"
              >
                <img src={reloadImg} alt="reload" className="mr-2" />
                Play Again
              </button>

              <button
                onClick={handleProceed}
                className="flex items-center px-6 py-1.5 app-button bg-btnBgColor text-white"
              >
                Proceed
                <img src={arrowImg} alt="arrow" className="ml-2" />
              </button>
            </div>
          )}
        </>
      )}

      {/* ================= CONTENT SCREEN ================= */}
      {!isIntroStage && (
        <div className="flex flex-col min-h-screen bg-white overflow-x-hidden px-4 pt-4">
          <Header />
          <div className="flex-1 flex flex-col md:flex-row items-center justify-center px-1 pt-5 max-w-9xl mx-auto">
            {/* Video */}
            <div className="w-full md:w-1/2 flex justify-start items-center pl-[14px] pr-[30px]">
              <video
                ref={videoRef}
                className="w-full max-w-[900px] h-auto rounded-md shadow-md cursor-pointer"
                controls
                disablePictureInPicture
                onPlay={goFullscreenReplay}
              >
                <source
                  src="https://t1developmentneedles.blob.core.windows.net/intro-videos/NH_Anti_Fraud_Notification.mp4?sp=r&st=2026-07-14T09:53:25Z&se=2031-04-09T18:08:25Z&sv=2026-02-06&sr=b&sig=QfgvxNH0w6TIWU1KPUo1lDXacXQ9XPNNj9RAcAsKTdE%3D"
                  type="video/mp4"
                />
              </video>
            </div>

            <div className="hidden md:block self-stretch w-[1px] bg-gray-300 mx-4 my-[5%]" />

            {/* Text */}
            {/* Text */}
            <div className="w-full md:w-1/2 flex flex-col justify-center px-4 sm:px-6 md:px-8 lg:px-10 mt-6 md:mt-0">
              <div className="max-w-[720px]">
                <h2
                  className="font-semibold mb-4 leading-snug
     app-title"
                >
                  Important note of Assessment Integrity
                </h2>

                <p className="mb-4 leading-relaxed app-body">
                  Before proceeding, please take a moment to watch the video.
                </p>

                <p className="mb-4 leading-relaxed app-body">
                  The video talks about malpractice, unethical behaviour,
                  assessment manipulation, etc.
                </p>

                <p
                  className="leading-relaxed
      app-body"
                >
                  By clicking <span className="font-semibold">"Proceed"</span>,
                  you confirm that you will adhere to all rules of fair practice
                  and integrity, and you commit to refraining from any activity
                  that is unethical, unlawful, or intended to gain unfair
                  advantage.
                </p>
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="mt-auto w-full flex gap-2 justify-end pb-4">
            <button
              onClick={goFullscreenReplay}
              className="btn-size flex bg-btnBgColor items-center px-6 py-1.5 text-white text-[16px]"
            >
              <img src={reloadImg} alt="reload" className="mr-2 w-4" />
              Play Again
            </button>

            <button
              onClick={handleProceed}
              className="flex items-center px-6 py-1.5 btn-size bg-btnBgColor text-white text-[16px]"
            >
              Proceed
              <img src={arrowImg} alt="arrow" className="ml-2" />
            </button>
          </div>

          <div className="w-full py-4 text-[10px] text-gray-600 text-center">
            ©{" "}
            {new Date().getFullYear() > 2026
              ? `2026-${new Date().getFullYear()}`
              : "2026"}
            , Needles and Haystacks Technology Pvt Ltd.
          </div>
        </div>
      )}
    </div>
  );
};

export default AssessmentInegrity;
